export default async function shareLink(data) {
    if (navigator.share) {
        try {
            await navigator.share(data);
        } catch (err) {
            console.error(err);
        }
    } else {
        try {
            await navigator.clipboard.writeText(data.url);
            alert("Copied to clipboard!");
        } catch (err) {
            console.error(err);
        }
    }
}
